<template>
  <b-overlay
    id="overlay-background"
    :show="ApiSettingloader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <validation-observer
              ref="refFormObserver"
            >
              <!-- form -->
              <b-form>
                <b-row>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Base URL"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_BASE_URL')"
                        label-for="bc-base-url"
                      >
                        <b-form-input
                          id="bc-base-url"
                          v-model="bc_setting_values.bc_base_url"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_BASE_URL')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Environment"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_ENVIRONMENT')"
                        label-for="module"
                      >
                        <v-select
                          v-model="bc_setting_values.bc_environment"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="environmentOptions"
                          :state="errors.length > 0 ? false:null"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="currencysettings"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Tenant"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_TENANT')"
                        label-for="bc-tenant"
                      >
                        <b-form-input
                          id="bc-tenant"
                          v-model="bc_setting_values.bc_tenant"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_TENANT')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC API Publisher"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_API_PUBLISHER')"
                        label-for="bc-api-publisher"
                      >
                        <b-form-input
                          id="bc-api-publisher"
                          v-model="bc_setting_values.bc_api_publisher"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_API_PUBLISHER')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Group"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_GROUP')"
                        label-for="bc-group"
                      >
                        <b-form-input
                          id="bc-group"
                          v-model="bc_setting_values.bc_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Debtia Test GUID"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_TEST_GUID')"
                        label-for="bc-test-guid"
                      >
                        <b-form-input
                          id="bc-test-guid"
                          v-model="bc_setting_values.bc_debtia_test_guid"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_TEST_GUID')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Client ID"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_CLIENT_ID')"
                        label-for="bc-client-id"
                      >
                        <b-form-input
                          id="bc-test-guid"
                          v-model="bc_setting_values.bc_client_id"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_CLIENT_ID')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Secret"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_SECRET')"
                        label-for="bc-secret"
                      >
                        <b-form-input
                          id="bc-secret"
                          v-model="bc_setting_values.bc_secret"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_SECRET')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC VendorPostingGroup"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_CREDITOR_VENDOR_POSTING_GROUP')"
                        label-for="bc-vendor_posting_group"
                      >
                        <b-form-input
                          id="bc-vendor_posting_group"
                          v-model="bc_setting_values.bc_creditor_vendor_posting_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_CREDITOR_VENDOR_POSTING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC VendorPostingGroup"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_DEBTOR_CUSTOMER_POSTING_GROUP')"
                        label-for="bc-customer_posting_group"
                      >
                        <b-form-input
                          id="bc-customer_posting_group"
                          v-model="bc_setting_values.bc_debtor_customer_posting_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_DEBTOR_CUSTOMER_POSTING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC genBusPostingGroup"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_CREDITOR_GEN_BUS_POSTING_GROUP')"
                        label-for="bc-genBusPostingGroup"
                      >
                        <b-form-input
                          id="bc-secret"
                          v-model="bc_setting_values.bc_creditor_gen_bus_posting_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_CREDITOR_GEN_BUS_POSTING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC genBusPostingGroup"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_DEBTOR_GEN_BUS_POSTING_GROUP')"
                        label-for="bc-genBusPostingGroup"
                      >
                        <b-form-input
                          id="bc-secret"
                          v-model="bc_setting_values.bc_debtor_gen_bus_posting_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_DEBTOR_GEN_BUS_POSTING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC vatBusPostingGroup"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_CREDITOR_VAT_BUS_POSTING_GROUP')"
                        label-for="bc-vatBusPostingGroup"
                      >
                        <b-form-input
                          id="bc-secret"
                          v-model="bc_setting_values.bc_creditor_vat_bus_posting_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_CREDITOR_VAT_BUS_POSTING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC vatBusPostingGroup"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_BC_DEBTOR_VAT_BUS_POSTING_GROUP')"
                        label-for="bc-vatBusPostingGroup"
                      >
                        <b-form-input
                          id="bc-secret"
                          v-model="bc_setting_values.bc_debtor_vat_bus_posting_group"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_BC_DEBTOR_VAT_BUS_POSTING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Document Sending Profile"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DOCUMENT_SENDING_PROFILE')"
                        label-for="document-sending-profile"
                      >
                        <b-form-input
                          id="document-sending-profile"
                          v-model="bc_setting_values.bc_debtor_document_sending_profile"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_DOCUMENT_SENDING_GROUP')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  block
                  variant="primary"
                  @click="postCurrencySettingValues"
                >
                  Save
                </b-button>
              </b-form>
              <!--/ form -->
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BFormInput, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      ApiSettingloader: false,
      required,
      currencyselected: 1,
      environmentOptions: [
        { label: 'Sandbox', value: 'sandbox' },
        { label: 'Production', value: 'production' },
      ],
      bc_setting_values: {
        bc_base_url: '',
        bc_environment: '',
        bc_tenant: '',
        bc_api_publisher: '',
        bc_group: '',
        bc_debtia_test_guid: '',
        bc_client_id: '',
        bc_secret: '',
        bc_debtor_customer_posting_group: '',
        bc_debtor_gen_bus_posting_group: '',
        bc_debtor_vat_bus_posting_group: '',
        bc_creditor_vendor_posting_group: '',
        bc_creditor_gen_bus_posting_group: '',
        bc_creditor_vat_bus_posting_group: '',
        bc_debtor_document_sending_profile: '',
      },
    }
  },
  watch: {
    settings: {
      handler() {
        this.mapValues()
      },
    },
    // role: {
    //   handler(selected) {
    //     this.settingsData(selected)
    //   },
    // },
  },
  methods: {
    mapValues() {
      Object.keys(this.bc_setting_values).forEach(element => {
        const item = this.settings.filter(word => word.key === element)
        if (item.length > 0) {
          this.bc_setting_values[element] = item[0].value
        }
      })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.ApiSettingloader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    postCurrencySettingValues() {
      this.$refs.refFormObserver.validate().then(success => {
        if (success) {
          this.ApiSettingloader = true
          const obj = [
            {
              key: 'bc_base_url',
              value: this.bc_setting_values.bc_base_url,
            },
            {
              key: 'bc_tenant',
              value: this.bc_setting_values.bc_tenant,
            },
            {
              key: 'bc_environment',
              value: this.bc_setting_values.bc_environment,
            },
            {
              key: 'bc_api_publisher',
              value: this.bc_setting_values.bc_api_publisher,
            },
            {
              key: 'bc_group',
              value: this.bc_setting_values.bc_group,
            },
            {
              key: 'bc_debtia_test_guid',
              value: this.bc_setting_values.bc_debtia_test_guid,
            },
            {
              key: 'bc_client_id',
              value: this.bc_setting_values.bc_client_id,
            },
            {
              key: 'bc_secret',
              value: this.bc_setting_values.bc_secret,
            },
            {
              key: 'bc_creditor_vendor_posting_group',
              value: this.bc_setting_values.bc_creditor_vendor_posting_group,
            },
            {
              key: 'bc_creditor_gen_bus_posting_group',
              value: this.bc_setting_values.bc_creditor_gen_bus_posting_group,
            },
            {
              key: 'bc_creditor_vat_bus_posting_group',
              value: this.bc_setting_values.bc_creditor_vat_bus_posting_group,
            },
            {
              key: 'bc_debtor_customer_posting_group',
              value: this.bc_setting_values.bc_debtor_customer_posting_group,
            },
            {
              key: 'bc_debtor_gen_bus_posting_group',
              value: this.bc_setting_values.bc_debtor_gen_bus_posting_group,
            },
            {
              key: 'bc_debtor_vat_bus_posting_group',
              value: this.bc_setting_values.bc_debtor_vat_bus_posting_group,
            },
            {
              key: 'bc_debtor_document_sending_profile',
              value: this.bc_setting_values.bc_debtor_document_sending_profile,
            },
          ]
          axios.post('user-settings/save', obj).then(response => {
            console.log(response)
            if (localStorage.getItem('bcSettings') === 'false') {
              localStorage.setItem('bcSettings', 'true')
              this.$router.go()
            }
            // this.ApiSettingloader = false
            // this.makeSuccessToast()

            // verify bc credentials
            // axios.post('user-settings/test-bc-credentials', obj).then(bcResponse => {
            //   console.log(bcResponse)
            //   this.ApiSettingloader = false
            //   this.makeSuccessToast()
            // }).catch(error => {
            //   // if (err.response.data.message) {
            //   //   this.alertErrors.push(err.response.data.message)
            //   // }
            //   this.makeFailureToast(error)
            // })
          }).catch(error => {
            // if (err.response.data.message) {
            //   this.alertErrors.push(err.response.data.message)
            // }
            this.makeFailureToast(error)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
